import styled, { css } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

/** Leaf module — avoids AssetFilter ↔ filters.style circular import. */
export const CustomFilterPopover = styled.div<{ $width?: string }>`
  &:not(.ant-table-filter-dropdown-checkboxes) {
    min-width: 16rem;
    max-width: 32rem;
  }
  ${({ $width }) => ($width ? `width: ${$width}` : '')};

  ${({ theme }) =>
    theme.themeName === Theme.Dark
      ? css`
          background-color: ${theme.tertiaryBackgroundColor} !important;
        `
      : ''}
`;
